<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="updateDisease" (change)="updateDiseaseChange()" (submit)="updateDiseaseSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "UPDATE_CHRONIC_DISEASE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/admission/chronic-disease"
                    *ngIf="!creating">
                    {{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-plus"></i>
                        {{ "UPDATE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "CHRONIC_DISEASE_AR_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="diseaseNameAr">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateDisease.controls.diseaseNameAr.touched && updateDisease.controls.diseaseNameAr.invalid && updateDisease.dirty">
                                    {{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "CHRONIC_DISEASE_EN_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="diseaseNameEn">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateDisease.controls.diseaseNameEn.touched && updateDisease.controls.diseaseNameEn.invalid && updateDisease.dirty">
                                    {{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "ORDER_ID" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="orderId">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateDisease.controls.orderId.touched && updateDisease.controls.orderId.invalid && updateDisease.dirty">
                                    {{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </form>
</div>

<app-loader [show]="showLoader"></app-loader>